<template>
    <div
        class="BaseVideo video lazyload"
        ref="BaseVideo"
        :class="{'BaseVideo--narrow' : this.narrow === true}"
        :data-youtube="youtubeData"
        :data-vimeo="vimeoData"
        :data-ytparams="videoParams"
        :style="videoImage"
    >
        <span
            class="BaseVideo__play"
            aria-hidden="true"
        >
            <slot/>
            <button
                class="BaseVideo__icon">
                <BaseIcon
                    icon="play-icon"
                    color="white"
                />
            </button>
        </span>
    </div>
</template>
<script>
export default {
    name: 'BaseVideo',
    data() {
        return {
            videoImage: {
                backgroundImage: {
                    type: String,
                    default: null
                }
            }
        }
    },
    props: {
        data: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        narrow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        youtubeData() {
            return this.type === 'youtube' ? this.data : null
        },
        vimeoData() {
            return this.type === 'vimeo' ? this.data : null
        },
        videoParams() {
            if (this.type === 'youtube') {
                return 'enablejsapi=1&modestbranding=1&showinfo=0&vq=hd720&rel=0&autoplay=0'
            } else {
                return 'color=ffffff&title=0&byline=0&portrait=0&badge=0'
            }
        }
    },
    mounted() {
        this.getThumbnailUrl();
    },
    methods: {
        getThumbnailUrl() {
            if(this.$refs.BaseVideo) {
                const bgSet = this.$refs.BaseVideo.getAttribute("data-bgset");
                const bgUrl = this.$refs.BaseVideo.style.backgroundImage;
                if (bgSet === null) {
                    if(bgUrl === '') {
                        setTimeout(() => {
                            this.getThumbnailUrl();
                        }, 200);
                    } else {
                        if (this.type === 'youtube') {
                            this.videoImage.backgroundImage = `url("https://img.youtube.com/vi/${this.data}/hqdefault.jpg") !important`
                        } else {
                            this.videoImage.backgroundImage =  `url("https://i.vimeocdn.com/video/${this.data}.jpg") !important`
                        }

                    }
                } else {
                    if (bgUrl === '' || bgUrl === null) {
                        setTimeout(() => {
                            this.getThumbnailUrl();
                        }, 200);
                    } else {
                        const newBgUrl = bgSet.substr(0,bgSet.indexOf(' '));
                        setTimeout(() => {
                            this.videoImage.backgroundImage = `url("${newBgUrl}") !important`
                        }, 1000);
                    }
                }
            } else {
                setTimeout(() => {
                    this.getThumbnailUrl();
                }, 200);
            }
        }
    }
}
</script>
<style lang="scss">

    .BaseVideo {
        position: relative;
        padding-bottom: 53%;
        height: 0;
        background-size: cover;
        background-position: center center;
        background-color: #EDEDED;
        background-image: none !important;
    }

    .BaseVideo--narrow {
        max-width: 800px;
        margin: auto;

        @include media-query(lap-and-up) {
            padding-bottom: 45%;
        }
    }

    .BaseVideo__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        cursor: pointer;
        background: $action-color;
        border: 2px solid getColor('white');
        border-radius: 50%;
        transition: all ease-out 0.345s;
        font-size: 2rem;

        &:hover {
            background: getColor('blue', 'charcoal');
        }

        @include media-query(lap-and-up) {
            width: 100px;
            height: 100px;
            font-size: 3rem;
        }
    }


    .BaseVideo iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }


    .BaseVideo__play {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 3rem;
        color: getColor('white');
        background: rgba(getColor('black'), 0.4);

        .BaseIcon {
            position: relative;
            left: 0.25rem;
        }
    }
</style>
